import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ProjectsSlice";
import { setBreadCrumb } from "../../../_utilities/breadCrumb";
import GetJobId from "../../../_utilities/GetJobId";
import ProjectsComponent from "../ProjectsComponent";

const initalState = { data: null, message: "", isloader: true };

const ProjectsEdit = () => {
  const getJobCode = GetJobId();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [projectDetails, setProjectDetails] = useState(null);

  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);

  useEffect(() => {
    if (getJobCode) {
      dispatch(_ser.getProjectsByIdAsync(getJobCode));
    }
  }, [getJobCode]);

  const projectDetailsResponse = useSelector(
    (state) => state.GetProjectsById.data,
  );

  useEffect(() => {
    if (projectDetailsResponse !== null && projectDetailsResponse.length > 0) {
      let projectData = JSON.parse(JSON.stringify(projectDetailsResponse));
      projectData[0].accessibleTo =
        JSON.parse(projectData[0].accessibleTo) || [];
      setProjectDetails(projectData[0]);
      dispatch(_ser.getProjectsByIdStartReducer(initalState));
      setBreadCrumb(projectData[0].id, projectData[0].name, "projects");
    }
  }, [projectDetailsResponse]);

  const code = useSelector((state) => state.EditProjects.data);

  const GetValidData = async (project) => {
    setBreadCrumb(project.id, project.name, "projects");
    try {
      delete project.selectedStatuses;
      await dispatch(_ser.editProjectsAsync(project.id, project));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (code === 200) {
      dispatch(_ser.editProjectsStartReducer(initalState));
      navigate(`/ats/layout/projects/view/${getJobCode}`);
    }
  }, [code]);

  const actionBtns = [
    {
      variant: "text",
      style: {
        color: "red",
        width: "6rem",
        fontWeight: "bolder",
        fontSize: "14px",
      },
      label: "Cancel",
      type: "back",
      class: "buttonHover",
      navigateTo: `/ats/layout/projects/view/${getJobCode}`,
    },
    {
      variant: "contained",
      style: {
        backgroundColor: "var(--primary-bg-color)",
        color: "var(--primary-background-text-color)",
        borderRadius: "10px",
        width: "6rem",
        fontSize: "14px",
      },
      navigateTo: null,
      label: "Save",
      type: "submit",
      class: "buttonHover1",
    },
  ];

  return (
    <React.Fragment>
      <div style={{ padding: "0 10px" }} id="projectsView">
        {projectDetails ? (
          <ProjectsComponent
            componentType="edit"
            actions={actionBtns}
            onValidData={GetValidData}
            input={projectDetails}
          />
        ) : (
          !showLoader &&
          !showUncommonLoader && (
            <div className="nodatasection">
              <img
                src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                alt="noData"
              />
              {"No data found"}
            </div>
          )
        )}
      </div>
    </React.Fragment>
  );
};

export default ProjectsEdit;
